import { memberApi } from '@formosa/shared/api/member';

/**
 * Travel-local thin wrapper for binary upload.
 * Ownership stays on MemberUploadController
 * ({@code POST /formosa-member/member/common/upload/oss/image}).
 * Returns Result.data = objectKey (path only; no OSS host).
 */
export const memberUploadApi = {
  uploadImage: (file) => memberApi.uploadOssImage(file),
};
